import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Button,
  Heading,
  Flex,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaRobot, FaTools, FaPlay } from "react-icons/fa";
import CollapsibleLeftNav from "../../components/common/CollapsibleLeftNav";
import AgentTable from "../../components/new_darwin_eva/AgentTable";
import ToolTable from "../../components/new_darwin_eva/ToolTable";
import EvaPlayground from "components/new_darwin_eva/EvaPlayground";


const EvaListPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeState = location.state as undefined | {
    activeSection?: string;
    initialDarwinAgentId?: string;
    initialPromptId?: string;
    startAtStepIndex?: number;
  };

  // Active section state
  const [activeSection, setActiveSection] = useState(routeState?.activeSection || "agents");

  const handleCreate = () => {
    navigate("/eva/agent/create");
  };

  const handleAgentsClick = () => {
    setActiveSection("agents");
  };

  const handleToolsClick = () => {
    setActiveSection("tools");
  };

  const handlePlaygroundClick = () => {
    setActiveSection("playground");
  };

  // Navigation items configuration
  const navItems = [
    {
      id: "agents",
      label: "Agents",
      icon: FaRobot,
      onClick: handleAgentsClick,
    },
    {
      id: "tools",
      label: "Tools",
      icon: FaTools,
      onClick: handleToolsClick,
    },
    {
      id: "playground",
      label: "Playground",
      icon: FaPlay,
      onClick: handlePlaygroundClick,
    },
  ];

  return (
    <Flex height="100%" gap={.5}>
      {/* Left Navigation Sidebar */}
      <CollapsibleLeftNav
        title="Eva Management"
        items={navItems}
        activeItemId={activeSection}
        defaultWidth={200}
        minWidth={180}
        maxWidth={350}
      />

      {/* Main Content Area */}
      <Box bg="bg.surface" boxShadow="lg" borderRadius="lg" overflowY="auto" flex="1">
        {activeSection === "agents" && (
          <VStack className="eva-list-content" spacing={6} p={6}>
            <HStack justify="space-between" w="full">
              <Heading size="m">Agents Management</Heading>
              <Button onClick={handleCreate} colorScheme="blue" size="sm">
                Create Agent
              </Button>
            </HStack>
            <AgentTable />
          </VStack>
        )}
        {activeSection === "tools" && (
          <VStack className="eva-list-content" spacing={6} p={6}>
            <Heading size="m">Tools Management</Heading>
            <ToolTable />
          </VStack>
        )}
        {activeSection === "playground" && (
          <EvaPlayground
            initialDarwinAgentId={routeState?.initialDarwinAgentId}
            initialPromptId={routeState?.initialPromptId}
            startAtStepIndex={routeState?.startAtStepIndex}
          />
        )}
      </Box>
    </Flex>
  );
};

export default EvaListPage;
